import { CategoryLabelContent, } from "src/modules/pe-landing-module/data/interfaces"
import { IPrimitiveProps } from "../section/Primitive"
import { Tag } from "@blueprintjs/core"
import { getContrastColor } from "src/libs/utilities"

/* Protopia Ecosystem component */ 
const CategoryLabelPrimitive = (props: IPrimitiveProps): JSX.Element => { 
    const primitive: CategoryLabelContent = ( props.primitive || {} ) as CategoryLabelContent 
    return primitive.data.title
        ?
        <div className="mx-1 flex-centered" data-primitive-type={primitive["data-primitive-type"]}> 
            <Tag className="py-1 px-3" style={{backgroundColor: primitive.category?.color}}>
                <div className="flex-centered small" style={{color: getContrastColor( primitive.category?.color || "#000000")}}>
                    <i className={`${primitive.category?.icon} mr-1`}></i>
                    <div className="letter-spacing-1">
                        { primitive.data.title }
                    </div>
                </div> 
            </Tag>
        </div> 
        :
        <></> 
}
export default CategoryLabelPrimitive